import React from 'react'

const MissionVision = () => {
  return (
    <div>MissionVision</div>
  )
}

export default MissionVision